import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4 mb-20" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-md-4 mb-20" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "col-md-4 mb-20" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-md-4 mb-20" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  class: "position-relative mt-2 p-2 bg-white shadow rounded",
  style: {"z-index":"999"}
}
const _hoisted_13 = { class: "col-md-4 mb-20" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "col-md-4 mb-20" }
const _hoisted_16 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_17 = { class: "p-15 p-md-20 border-bottom d-flex flex-wrap align-items-center justify-content-between gap-2" }
const _hoisted_18 = { class: "d-flex align-items-center flex-wrap gap-2" }
const _hoisted_19 = { class: "d-flex align-items-center gap-1" }
const _hoisted_20 = { class: "mb-0 text-nowrap" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_23 = {
  key: 1,
  class: "flaticon-calculator me-1"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_26 = {
  key: 1,
  class: "flaticon-calculator me-1"
}
const _hoisted_27 = {
  key: 0,
  class: "fw-semibold text-dark"
}
const _hoisted_28 = { class: "text-success" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "position-relative" }
const _hoisted_31 = { class: "p-15 p-md-20" }
const _hoisted_32 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_33 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_34 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_35 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_36 = {
  key: 0,
  class: "badge rounded-pill fs-13 text-bg-danger"
}
const _hoisted_37 = {
  key: 1,
  class: "badge rounded-pill fs-13 text-bg-info"
}
const _hoisted_38 = {
  key: 2,
  class: "badge rounded-pill fs-13 text-bg-success"
}
const _hoisted_39 = {
  key: 5,
  class: "dropdown"
}
const _hoisted_40 = { class: "dropdown-menu" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { key: 2 }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { key: 3 }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { key: 4 }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { key: 5 }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { key: 6 }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { key: 6 }
const _hoisted_56 = {
  class: "modal fade",
  id: "modal_PaidBox",
  tabindex: "-1",
  "aria-labelledby": "modalPaidBoxLabel",
  "aria-hidden": "true"
}
const _hoisted_57 = { class: "modal-dialog modal-lg" }
const _hoisted_58 = { class: "modal-content" }
const _hoisted_59 = { class: "modal-header" }
const _hoisted_60 = {
  class: "modal-title",
  id: "modalPaidBoxLabel"
}
const _hoisted_61 = { class: "modal-body" }
const _hoisted_62 = { class: "row mb-3" }
const _hoisted_63 = { class: "col-12" }
const _hoisted_64 = { class: "row mb-3" }
const _hoisted_65 = { class: "col-12" }
const _hoisted_66 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_MyDateRangePicker = _resolveComponent("MyDateRangePicker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[18] || (_cache[18] = _createElementVNode("label", null, "Zone:", -1)),
                _createVNode(_component_v_select, {
                  class: "custom-select-height",
                  label: "name",
                  options: _ctx.ZonesList,
                  modelValue: _ctx.zone_filter,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.zone_filter) = $event))
                }, null, 8, ["options", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[19] || (_cache[19] = _createElementVNode("label", null, "Livreur :", -1)),
                _createVNode(_component_v_select, {
                  class: "custom-select-height",
                  label: "name",
                  options: _ctx.LivreursList,
                  modelValue: _ctx.liv_filter,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.liv_filter) = $event))
                }, null, 8, ["options", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[21] || (_cache[21] = _createElementVNode("label", null, "Statut:", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "custom-select-height form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status_filter) = $event))
                }, _cache[20] || (_cache[20] = [
                  _createElementVNode("option", {
                    value: "",
                    selected: ""
                  }, "Status (Tous)", -1),
                  _createElementVNode("option", {
                    value: 0,
                    selected: ""
                  }, "Nouveau", -1),
                  _createElementVNode("option", {
                    value: 1,
                    selected: ""
                  }, "Enregistré", -1),
                  _createElementVNode("option", { value: 2 }, "Payé", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.status_filter]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[23] || (_cache[23] = _createElementVNode("label", null, "Par Date :", -1)),
                _createElementVNode("div", {
                  class: "border p-2 cursor-pointer",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCalendar()))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.selectedDate?.[0]?.format("DD MMM YYYY") || "—") + " - " + _toDisplayString(_ctx.selectedDate?.[1]?.format("DD MMM YYYY") || "—") + " ", 1),
                  _cache[22] || (_cache[22] = _createElementVNode("i", { class: "flaticon-calendar float-end" }, null, -1))
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_MyDateRangePicker, {
                    modelValue: _ctx.selectedDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDate) = $event)),
                    onOnSelect: _ctx.showCalendar,
                    enableSecondCalendar: true
                  }, null, 8, ["modelValue", "onOnSelect"])
                ], 512), [
                  [_vShow, _ctx.showCalendarBox]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[24] || (_cache[24] = _createElementVNode("label", null, "Créer par:", -1)),
                _createVNode(_component_v_select, {
                  class: "custom-select-height",
                  modelValue: _ctx.created_filter,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.created_filter) = $event)),
                  label: "name",
                  options: _ctx.CuserList,
                  onSearch: _ctx.onSearchUsers
                }, null, 8, ["modelValue", "options", "onSearch"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                style: {"margin-top":"22px"},
                class: "btn btn-primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.applyFilters()))
              }, _cache[25] || (_cache[25] = [
                _createElementVNode("i", {
                  class: "flaticon-search",
                  style: {"margin-right":"5px"}
                }, null, -1),
                _createTextVNode(" Filtrer ", -1)
              ])),
              _createElementVNode("button", {
                style: {"margin-top":"22px"},
                class: "btn btn-danger",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resetFilters()))
              }, _cache[26] || (_cache[26] = [
                _createElementVNode("i", {
                  class: "flaticon-close",
                  style: {"margin-right":"5px"}
                }, null, -1),
                _createTextVNode(" Annuler ", -1)
              ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "mb-0 text-nowrap" }, "Voir", -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.users.per_page,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.users.per_page) = $event)),
                options: [10, 25, 50],
                clearable: false,
                class: "per-page-selector d-inline-block",
                style: {"min-width":"75px"},
                onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getRecords()))
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_20, "sur " + _toDisplayString(_ctx.users.total) + " entités", 1)
            ]),
            _createElementVNode("button", {
              disabled: _ctx.load,
              class: "btn btn-sm btn-outline-secondary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handelTotal(0)))
            }, [
              (_ctx.load)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                : (_openBlock(), _createElementBlock("i", _hoisted_23)),
              _cache[28] || (_cache[28] = _createTextVNode(" Total sélection ", -1))
            ], 8, _hoisted_21),
            _createElementVNode("button", {
              disabled: _ctx.load,
              class: "btn btn-sm btn-outline-info",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handelTotal(1)))
            }, [
              (_ctx.load)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                : (_openBlock(), _createElementBlock("i", _hoisted_26)),
              _cache[29] || (_cache[29] = _createTextVNode(" Total (Tous) ", -1))
            ], 8, _hoisted_24),
            (_ctx.showTotal && _ctx.total)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                  _cache[30] || (_cache[30] = _createTextVNode(" Total : ", -1)),
                  _createElementVNode("b", _hoisted_28, _toDisplayString(_ctx.total) + " DH", 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-success",
              disabled: _ctx.selectedPays.length === 0,
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.exportSelected && _ctx.exportSelected(...args)))
            }, _cache[31] || (_cache[31] = [
              _createElementVNode("i", { class: "flaticon-download me-1" }, null, -1),
              _createTextVNode(" Exporter sélection ", -1)
            ]), 8, _hoisted_29),
            (_ctx.auth.can('ADD_BP_L'))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "btn btn-sm btn-primary",
                  to: { name: 'NewPaymentPage' }
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createElementVNode("i", { class: "flaticon-plus me-1" }, null, -1),
                    _createTextVNode(" Ajouter Bon ", -1)
                  ])),
                  _: 1,
                  __: [32]
                }))
              : _createCommentVNode("", true),
            (_ctx.auth.can('ADD_BP_L'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-sm btn-info",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.autoAddedNotes()))
                }, _cache[33] || (_cache[33] = [
                  _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
                  _createTextVNode(" Auto-ajouter ", -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.users.searchTerm) = $event)),
              type: "text",
              class: "form-control form-control-sm rounded-1 ps-4",
              style: {"min-width":"260px"},
              placeholder: "Rechercher...",
              onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
            }, null, 544), [
              [_vModelText, _ctx.users.searchTerm]
            ]),
            _cache[34] || (_cache[34] = _createElementVNode("i", {
              class: "flaticon-search position-absolute top-50 translate-middle-y ms-2",
              style: {"left":"0","opacity":"0.4","pointer-events":"none"}
            }, null, -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_vue_good_table, {
            "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Bons Sélectionés',
          disableSelectInfo: true,
        },
            onSelectedRowsChange: _ctx.selectPays,
            onSelectAll: _ctx.onSelectAllPays,
            columns: _ctx.columns,
            rows: _ctx.rows,
            responsive: ""
          }, {
            emptystate: _withCtx(() => [
              _createVNode(_component_center, null, {
                default: _withCtx(() => _cache[35] || (_cache[35] = [
                  _createTextVNode("Aucune entrées correspondants trouvés", -1)
                ])),
                _: 1,
                __: [35]
              })
            ]),
            "table-row": _withCtx((props) => [
              (props.column.field === 'note_ref')
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                    _createElementVNode("b", null, _toDisplayString(props.row.note_ref), 1)
                  ]))
                : (props.column.field === 'zone_name')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                      _createTextVNode(_toDisplayString(props.row.zone_name), 1),
                      _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(props.row.agency_name), 1)
                    ]))
                  : (props.column.field === 'created_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                        (props.row.created_at != null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                              _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1))
                            ], 64))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(props.row.by_name), 1)
                      ]))
                    : (props.column.field === 'total')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(props.row.total) + " DH ", 1))
                      : (props.column.field === 'statut')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            (props.row.statut == 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, " Nouveau "))
                              : (props.row.statut == 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, " Enregistré "))
                                : (props.row.statut == 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, " Payé "))
                                  : _createCommentVNode("", true)
                          ], 64))
                        : (props.column.field === 'action')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _cache[45] || (_cache[45] = _createElementVNode("button", {
                                class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                type: "button",
                                id: "dropdownMenuButton",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false"
                              }, [
                                _createElementVNode("i", { class: "flaticon-dots" })
                              ], -1)),
                              _createElementVNode("ul", _hoisted_40, [
                                (_ctx.auth.can('BP_L'))
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        href: "#",
                                        onClick: _withModifiers(($event: any) => (
                      _ctx.openNewWindow(
                        `/edit-payment-note/${props.row.id}/${props.row.note_ref}`
                      )
                    ), ["prevent"])
                                      }, _cache[38] || (_cache[38] = [
                                        _createElementVNode("i", { class: "flaticon-eye me-2" }, null, -1),
                                        _createTextVNode(" Détails du Bon ", -1)
                                      ]), 8, _hoisted_42)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                    props.row.statut == 0 &&
                    props.row.total_parcel == 0 &&
                    _ctx.auth.can('BP_L')
                  )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_43, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        href: "#",
                                        onClick: _withModifiers(($event: any) => (_ctx.RemoveNote(props.row)), ["prevent"])
                                      }, _cache[39] || (_cache[39] = [
                                        _createElementVNode("i", { class: "flaticon-delete me-2" }, null, -1),
                                        _createTextVNode(" Supprimer le Bon ", -1)
                                      ]), 8, _hoisted_44)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                    props.row.statut == 0 &&
                    props.row.total_parcel != 0 &&
                    _ctx.auth.can('BP_L')
                  )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        href: "#",
                                        onClick: _withModifiers(($event: any) => (_ctx.SaveBon(props.row)), ["prevent"])
                                      }, _cache[40] || (_cache[40] = [
                                        _createElementVNode("i", { class: "flaticon-diskette me-2" }, null, -1),
                                        _createTextVNode(" Enregistrer le bon ", -1)
                                      ]), 8, _hoisted_46)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                    props.row.statut == 1 &&
                    props.row.total_parcel != 0 &&
                    _ctx.auth.can('BP_L')
                  )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        href: "#",
                                        onClick: _withModifiers(($event: any) => (_ctx.OpenBon(props.row)), ["prevent"])
                                      }, _cache[41] || (_cache[41] = [
                                        _createElementVNode("i", { class: "flaticon-unlock me-2" }, null, -1),
                                        _createTextVNode(" Ouvrir le bon ", -1)
                                      ]), 8, _hoisted_48)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                    props.row.statut == 1 &&
                    props.row.total_parcel != 0 &&
                    props.row.total > 0 &&
                    _ctx.auth.can('BP_L') &&
                    _ctx.auth.can('PAID_BP_L')
                  )
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        href: "#",
                                        onClick: _withModifiers(($event: any) => (_ctx.showModalPaid(props.row)), ["prevent"])
                                      }, _cache[42] || (_cache[42] = [
                                        _createElementVNode("i", { class: "flaticon-money me-2" }, null, -1),
                                        _createTextVNode(" Changer En Payé ", -1)
                                      ]), 8, _hoisted_50)
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.total_parcel != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        href: "#",
                                        onClick: _withModifiers(($event: any) => (_ctx.GetPDF(props.row)), ["prevent"])
                                      }, _cache[43] || (_cache[43] = [
                                        _createElementVNode("i", { class: "flaticon-download me-2" }, null, -1),
                                        _createTextVNode(" Télécharger le bon ", -1)
                                      ]), 8, _hoisted_52)
                                    ]))
                                  : _createCommentVNode("", true),
                                (props.row.total_parcel != 0)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        href: "#",
                                        onClick: _withModifiers(($event: any) => (_ctx.exportPayNote(props.row)), ["prevent"])
                                      }, _cache[44] || (_cache[44] = [
                                        _createElementVNode("i", { class: "flaticon-file me-2" }, null, -1),
                                        _createTextVNode(" Exporter Excel ", -1)
                                      ]), 8, _hoisted_54)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(props.formattedRow[props.column.field]), 1))
            ]),
            _: 1
          }, 8, ["onSelectedRowsChange", "onSelectAll", "columns", "rows"]),
          _createVNode(_component_PaginatorContent, {
            pagination: _ctx.users,
            offset: 9,
            onPaginate: _ctx.getRecords
          }, null, 8, ["pagination", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("h5", _hoisted_60, " Paiment Bon " + _toDisplayString(_ctx.form.note_ref), 1),
            _cache[46] || (_cache[46] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("span", null, [
                  _cache[47] || (_cache[47] = _createTextVNode("Montant à payé: ", -1)),
                  _createElementVNode("b", null, _toDisplayString(_ctx.form.total), 1)
                ])
              ])
            ]),
            _cache[49] || (_cache[49] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _cache[48] || (_cache[48] = _createElementVNode("label", {
                  for: "price",
                  class: "form-label"
                }, "Montant payé", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  min: "0",
                  id: "price",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.pricePaid) = $event)),
                  class: "form-control",
                  placeholder: "Montant Payé"
                }, null, 512), [
                  [_vModelText, _ctx.pricePaid]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _cache[50] || (_cache[50] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Annuler ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.BonPaid(_ctx.form)))
            }, " Payé ")
          ])
        ])
      ])
    ])
  ], 64))
}